import { __awaiter, __generator, __values } from "tslib";
import { log } from '../logging/broadcastLogger';
import { LogKind } from '../logging/log.types';
function decorateElement(element, attributes) {
    if (!attributes) {
        return;
    }
    for (var attr in attributes) {
        if (attributes.hasOwnProperty(attr)) {
            // this can be any attributes
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ;
            element[attr] = attributes[attr];
        }
    }
}
/**
 * Get the locale from the bundle url of a Centro HVC.
 *
 * @param cdnUrl - The URL of the bundle from the Centro CDN.
 * @returns The locale key.
 */
export function extractLocaleFromBundle(cdnUrl) {
    var match = cdnUrl.match(/\.([a-z]{2,3}(?:-[A-Za-z]+)*)\.bundle\.js/);
    return match ? match[1] : null;
}
function loadScriptUrl(leaf, sourceDOM, trustedTypePolicy) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            // @ts-ignore TODO: TS Bug, remove once upgrade
            return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                    function attemptToLoadScript(retry) {
                        return __awaiter(this, void 0, void 0, function () {
                            var scriptElement, scriptUrl;
                            var _this = this;
                            return __generator(this, function (_a) {
                                scriptElement = sourceDOM.createElement('script');
                                scriptUrl = (trustedTypePolicy === null || trustedTypePolicy === void 0 ? void 0 : trustedTypePolicy.createScriptURL)
                                    ? trustedTypePolicy.createScriptURL(leaf.content)
                                    : leaf.content;
                                scriptElement.src = scriptUrl;
                                scriptElement.onload = function () {
                                    if (!retry) {
                                        log({
                                            type: LogKind.Info,
                                            message: "Script successfully loaded after retry: " + scriptUrl,
                                            id: '536622',
                                            data: {
                                                script: scriptUrl,
                                            },
                                        });
                                    }
                                    resolve();
                                };
                                scriptElement.onerror = function () { return __awaiter(_this, void 0, void 0, function () {
                                    var response, contentTypeHeader, requestIdHeader, cdnProviderHeader, err_1;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                scriptElement.remove();
                                                _a.label = 1;
                                            case 1:
                                                _a.trys.push([1, 6, , 7]);
                                                return [4 /*yield*/, fetch(scriptUrl)];
                                            case 2:
                                                response = _a.sent();
                                                contentTypeHeader = response.headers.get('content-type');
                                                requestIdHeader = response.headers.get('x-ms-request-id');
                                                cdnProviderHeader = response.headers.get('x-cdn-provider');
                                                if (!retry) return [3 /*break*/, 4];
                                                log({
                                                    type: LogKind.Info,
                                                    message: "Retrying to load script: " + scriptUrl + ". Status: " + response.status,
                                                    id: '536623',
                                                    data: {
                                                        script: scriptUrl,
                                                        status: response.status,
                                                        contentType: contentTypeHeader,
                                                        requestId: requestIdHeader,
                                                        cdnProvider: cdnProviderHeader,
                                                    },
                                                });
                                                return [4 /*yield*/, attemptToLoadScript(false)];
                                            case 3:
                                                _a.sent();
                                                return [3 /*break*/, 5];
                                            case 4:
                                                log({
                                                    type: LogKind.Info,
                                                    message: "Failed to load script after retry: " + scriptUrl + ". Status: " + response.status,
                                                    id: '536624',
                                                    data: {
                                                        script: scriptUrl,
                                                        status: response.status,
                                                        contentType: contentTypeHeader,
                                                        requestId: requestIdHeader,
                                                        cdnProvider: cdnProviderHeader,
                                                    },
                                                });
                                                reject(new Error("Dynamically loading script " + scriptUrl + " failed. Status: " + response.status + ", content-type: " + contentTypeHeader + ", x-ms-request-id: " + requestIdHeader + ", x-cdn-provider: " + cdnProviderHeader));
                                                _a.label = 5;
                                            case 5: return [3 /*break*/, 7];
                                            case 6:
                                                err_1 = _a.sent();
                                                reject(new Error("Dynamically loading script " + scriptUrl + " failed: " + err_1));
                                                return [3 /*break*/, 7];
                                            case 7: return [2 /*return*/];
                                        }
                                    });
                                }); };
                                decorateElement(scriptElement, leaf.attributes);
                                sourceDOM.body.appendChild(scriptElement);
                                return [2 /*return*/];
                            });
                        });
                    }
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, attemptToLoadScript(true)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); })];
        });
    });
}
function loadScript(leaf, sourceDOM) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // @ts-ignore TODO: TS Bug, remove once upgrade
            return [2 /*return*/, new Promise(function (resolve) {
                    var scriptElement = sourceDOM.createElement('script');
                    var inlineScript = sourceDOM.createTextNode(leaf.content);
                    scriptElement.appendChild(inlineScript);
                    decorateElement(scriptElement, leaf.attributes);
                    sourceDOM.body.appendChild(scriptElement);
                    resolve();
                })];
        });
    });
}
function loadStyleUrl(leaf) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // @ts-ignore TODO: TS Bug, remove once upgrade
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var linkElement = document.createElement('link');
                    linkElement.rel = 'stylesheet';
                    linkElement.type = 'text/css';
                    linkElement.href = leaf.content;
                    linkElement.onload = function () {
                        resolve();
                    };
                    linkElement.onerror = function () {
                        reject(new Error("Dynamically loading style " + leaf.content + " failed"));
                    };
                    decorateElement(linkElement, leaf.attributes);
                    document.head.appendChild(linkElement);
                })];
        });
    });
}
function loadStyle(leaf) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // @ts-ignore TODO: TS Bug, remove once upgrade
            return [2 /*return*/, new Promise(function (resolve) {
                    var linkElement = document.createElement('link');
                    linkElement.rel = 'stylesheet';
                    linkElement.type = 'text/css';
                    var inlineStyle = document.createTextNode(leaf.content);
                    linkElement.appendChild(inlineStyle);
                    decorateElement(linkElement, leaf.attributes);
                    document.head.appendChild(linkElement);
                    resolve();
                })];
        });
    });
}
export function dynamicLoader(node, trustedTypePolicy, targetHtmlElementDom) {
    if (targetHtmlElementDom === void 0) { targetHtmlElementDom = document; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, err_2, _b, _c, script, e_1_1, err_3;
        var e_1, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _a = node.type;
                    switch (_a) {
                        case 'parallel': return [3 /*break*/, 1];
                        case 'sequential': return [3 /*break*/, 5];
                        case 'scriptUrl': return [3 /*break*/, 16];
                        case 'script': return [3 /*break*/, 18];
                        case 'styleUrl': return [3 /*break*/, 20];
                        case 'style': return [3 /*break*/, 22];
                    }
                    return [3 /*break*/, 24];
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Promise.all(node.children.map(function (n) {
                            return dynamicLoader(n, trustedTypePolicy);
                        }))];
                case 2:
                    _e.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _e.sent();
                    if (node.optional) {
                        console.log('Dynamic loading of optional script failed', err_2);
                    }
                    else {
                        throw err_2;
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
                case 5:
                    _e.trys.push([5, 14, , 15]);
                    _e.label = 6;
                case 6:
                    _e.trys.push([6, 11, 12, 13]);
                    _b = __values(node.children), _c = _b.next();
                    _e.label = 7;
                case 7:
                    if (!!_c.done) return [3 /*break*/, 10];
                    script = _c.value;
                    return [4 /*yield*/, dynamicLoader(script, trustedTypePolicy)];
                case 8:
                    _e.sent();
                    _e.label = 9;
                case 9:
                    _c = _b.next();
                    return [3 /*break*/, 7];
                case 10: return [3 /*break*/, 13];
                case 11:
                    e_1_1 = _e.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 13];
                case 12:
                    try {
                        if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 13: return [3 /*break*/, 15];
                case 14:
                    err_3 = _e.sent();
                    if (node.optional) {
                        console.log('Dynamic loading of optional script failed', err_3);
                    }
                    else {
                        throw err_3;
                    }
                    return [3 /*break*/, 15];
                case 15: return [2 /*return*/];
                case 16: return [4 /*yield*/, loadScriptUrl(node, targetHtmlElementDom, trustedTypePolicy)];
                case 17:
                    _e.sent();
                    return [2 /*return*/];
                case 18: return [4 /*yield*/, loadScript(node, targetHtmlElementDom)];
                case 19:
                    _e.sent();
                    return [2 /*return*/];
                case 20: return [4 /*yield*/, loadStyleUrl(node)];
                case 21:
                    _e.sent();
                    return [2 /*return*/];
                case 22: return [4 /*yield*/, loadStyle(node)];
                case 23:
                    _e.sent();
                    return [2 /*return*/];
                case 24: throw new Error("Invalid script loader object " + JSON.stringify(node));
            }
        });
    });
}
